import { AxiosInstance } from 'axios';
import { Result } from 'services/Result';
import { AdminModule, AdminModuleListEntry, AdminModulesSortPayload, NewAdminModule } from 'types/admin/modules';

export class ModuleListService {
  private axiosInstance: AxiosInstance;
  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getModuleList = async () => {
    const response = await this.axiosInstance.get<Result<AdminModuleListEntry[]>>('/api/admin/learning-hub/modules');
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
  };

  getModule = async (id: string) => {
    const response = await this.axiosInstance.get<Result<AdminModule>>(`/api/admin/learning-hub/modules/${id}`);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
  };

  createModule = async (module: NewAdminModule) => {
    const response = await this.axiosInstance.post('/api/admin/learning-hub/modules', module);

    if (response.status === 200) {
      return null;
    }
    throw Error('There was an internal error while creating new module.');
  };

  updateModule = async (module: AdminModule) => {
    const response = await this.axiosInstance.put('/api/admin/learning-hub/modules', module);

    if (response.status === 200) {
      return null;
    }
    throw Error('There was an internal error while updating a module.');
  };

  getCompletedTranslations = async (moduleId: string) => {
    const response = await this.axiosInstance.get<Result<string[]>>(`/api/admin/learning-hub/modules/${moduleId}/completed-translations`);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error('There was an internal error while getting translations.');
  };

  sortModules = async (payload: AdminModulesSortPayload) => {
    const response = await this.axiosInstance.post<Result<any>>('/api/admin/learning-hub/modules/sort', payload);
    console.log(response);
  };
}
